module.exports = __webpack_public_path__ + "img/ZACHOWYWANIE.eecd060c.png";